import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: '4', label: 'Flagship Products', suffix: '' },
  { value: '100', label: 'Active Users', suffix: 'k+' },
  { value: '15', label: 'Industries Served', suffix: '+' },
  { value: '24/7', label: 'Infrastructure Uptime', suffix: '' },
];

const Stats = () => {
  return (
    <section className="py-16 md:py-24 bg-white border-y border-slate-200 relative z-20">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 divide-x divide-slate-100">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center px-4"
            >
              <div className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-2 tracking-tight">
                {stat.value}<span className="text-indigo-600">{stat.suffix}</span>
              </div>
              <div className="text-sm md:text-base text-slate-500 font-medium">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;